import { List, Create, Edit, Users } from "../Components/index.js";

export default [
    {
        path: "/admin/district/:district_id/upazila",
        component: List,
        name: "upazila-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/upazila/:upazila_id/users",
        component: Users,
        name: "upazila-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/district/:district_id/upazila/:id/edit",
        component: Edit,
        name: "upazila-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/district/:district_id/upazila/create",
        component: Create,
        name: "upazila-create",
        meta: {
            requiresAuth: true,
        },
    },
];
